/* src/app/shared/polyline-map/polyline-map.component.scss */
div {
  overflow: hidden;
}
/*# sourceMappingURL=polyline-map.component.css.map */
